/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$footer-bar-background-color: #ffffff !default;
$footer-bar-link-color: #262626 !default;
$footer-bar-link-hover-color: #262626 !default;
$footer-bar-copyright-color: #999999 !default;
$section-margin-phone: 24px !default;
$section-margin-tablet: 32px !default;
$section-margin-desktop: 40px !default;
$section-margin-desktop-large: 48px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  font-family: $font-family-base;
}

::slotted(eon-ui-link) {
  --contentColor: #{$footer-bar-link-color};
  --contentHoverColor: #{$footer-bar-link-hover-color};
  --contentFocusColor: #{$footer-bar-link-hover-color};
}

::slotted(img) {
  display: block;
  height: 100%;
}

footer {
  position: relative;
  background-color: $footer-bar-background-color;

  .#{$prefix}footer-content-wrapper {
    position: relative;
    max-width: $content-max-width-desktop-l;
    padding: 48px $section-margin-desktop-large 48px $section-margin-desktop-large;
    margin: 0 auto 0 auto;

    @include for-size(desktop) {
      padding: 40px $section-margin-desktop 40px $section-margin-desktop;
      max-width: $content-max-width-desktop;
    }

    @include for-size(tablet) {
      padding: 32px $section-margin-tablet 32px $section-margin-tablet;
      max-width: 100%;
    }

    @include for-size(phone) {
      padding: 24px $section-margin-phone 24px $section-margin-phone;
      max-width: 100%;
    }

    .#{$prefix}footer-top-wrapper {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 48px;
      gap: 24px;
      flex-wrap: wrap;

      @include for-size(phone) {
        justify-content: flex-start;
        flex-direction: column;
        align-items: flex-start;
      }
    }

    .#{$prefix}footer-bottom-wrapper {
      position: relative;
      display: flex;
      justify-content: flex-start;
      gap: 24px;
      flex-wrap: wrap;

      @include for-size(phone) {
        flex-direction: column;
        gap: 16px;
      }
    }

    .#{$prefix}socialmedia {
      display: flex;
      width: 100%;
      flex-basis: 0%;
      gap: 16px;
    }

    .#{$prefix}copyright {
      font-family: $font-family-base;
      font-size: $copy-small-font-size;
      font-weight: $font-weight-regular;
      color: $footer-bar-copyright-color;
    }

    .#{$prefix}logo {
      position: relative;
      flex-shrink: 0;
      flex-basis: 20%;
    }

    .#{$prefix}links {
      display: flex;
      row-gap: 8px;
      column-gap: 16px;
      flex-wrap: wrap;
    }
  }
}
